import { iterateEntries } from "../../../../../../../Common/IterableUtils";
import { reject } from "../../../../../../../Common/TypingUtils";

import { Length } from "./CssLength";

/* eslint-disable prettier/prettier */
export type AsCSS<T> = {
    [K in keyof T]?:
        T[K] extends Length ? (string | number) :
        T[K]
}
/* eslint-enable prettier/prettier */

export type ThemeObject<T> = T & {
    css(): AsCSS<T>;
};

interface ThemeObjectIn {
    [key: string]: Length | string | number;
}

export function themeObject<T extends ThemeObjectIn>(obj: T): ThemeObject<T> {
    let cssObj: undefined | AsCSS<T> = undefined;
    return {
        ...obj,
        css: () => {
            if (cssObj != undefined) {
                return cssObj;
            }
            cssObj = {};
            for (const [name, value] of iterateEntries(obj)) {
                if (cssObj == undefined) {
                    continue;
                }
                if (value instanceof Length) {
                    // @ts-ignore
                    cssObj[name] = value.css();
                } else {
                    // @ts-ignore
                    cssObj[name] = value;
                }
            }
            return cssObj ?? reject();
        },
    };
}
